import { makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
    paper: {
        marginTop: '20px',
    },
    gridContainer: {
        paddingLeft: '35px',
        paddingRight: '35px',
        paddingTop: '15px',
        alignItems: 'flex-end',
    },
    filterInput: {
        width: '100%',
    },
    button: {
        color: 'white',
        backgroundColor: '#107A98',
        height: '36px',
        '&:hover': {
            backgroundColor: '#004763!important',
        },
    },
    dateCell: {
        whiteSpace: 'nowrap',
    },
    truncationNotice: {
        margin: '15px 35px 0 35px',
        padding: '10px 15px',
        borderLeft: '4px solid #F0AD4E',
        backgroundColor: '#FDF6E7',
        color: '#6B5424',
        fontSize: '14px',
    },
}));
